import { inventoryItemIdFormat } from "@redotech/redo-ims-id";
import { ScanKind } from "@redotech/redo-inventory-common/scan-kind";
import { locationIdFormat } from "@redotech/redo-inventory-id";
import { productIdFormat } from "@redotech/redo-product-id";
import { storageLocationIdFormat } from "@redotech/redo-warehouse-id";
import * as z from "zod";

const baseInput = z.object({
  locationId: locationIdFormat.schema,
  storageLocationId: storageLocationIdFormat.schema,
  quantity: z.number().int().min(1),
});

export const transferItemToBin = {
  name: "transferItemToBin" as const,
  input: z.discriminatedUnion("type", [
    baseInput.extend({
      type: z.literal(ScanKind.product),
      productId: productIdFormat.schema,
      overrideStrictLicensePlateScan: z.boolean().optional(),
    }),
    baseInput.extend({
      type: z.literal(ScanKind.inventoryItem),
      inventoryItemId: inventoryItemIdFormat.schema,
      overrideTransferValidation: z.boolean().optional(),
    }),
  ]),
  output: z.object({ success: z.boolean() }),
};
